import { render, staticRenderFns } from "./news-article.vue?vue&type=template&id=03ca07be&"
import script from "./news-article.vue?vue&type=script&lang=js&"
export * from "./news-article.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports